<form [formGroup]="userForm" *transloco="let t; read: 'cockpit'">
  <div class="flex-row">
    <div class="general-info flex-column">
      <div class="form-field mat-form-field-wrapper">
        <mat-slide-toggle formControlName="enabled" color="warn">{{ t('enabled') }}</mat-slide-toggle>
      </div>

      @for (field of formFields; track field) {
      <mat-form-field>
        <mat-label>{{ t(field.label) }}</mat-label>
        @if (field.type === 'input') {
        <input matInput [formControlName]="field.name" required />
        } @if (field.type === 'select') {
        <mat-select formControlName="language" required>
          @for (option of field.options; track option) {
          <mat-option [value]="option.value">{{ t(option.label) }}</mat-option>
          }
        </mat-select>
        }
        <mat-error>{{ field.errorMessage | transloco }}</mat-error>
      </mat-form-field>
      }

      <sibat-primary-button (clicked)="onSubmit()" [label]="'cockpit.submit' | transloco"></sibat-primary-button>
    </div>

    <div class="role-context flex-column">
      <div class="role">
        <mat-label>{{ t('role') }}</mat-label>
        <mat-chip-listbox>
          @for (role of (roles$ | async); track role) {
          <mat-chip-option
            selectable
            [class.selected]="userForm.get('roles')?.value.includes(role.code)"
            [disabled]="role.code === 'role_api'"
            (click)="toggleRole(role.code)"
          >
            @if (isRoleSelected(role.code)) {
            <mat-icon matChipAvatar>check</mat-icon>
            }
            {{ role.name }}
          </mat-chip-option>
          }
        </mat-chip-listbox>
        <mat-error>{{ 'errors.requiredField' | transloco }}</mat-error>
      </div>

      <ng-container formArrayName="roleContextValues">
        @for (contextControl of roleContextValues.controls; track contextControl; let i = $index) {
        <ng-container [formGroupName]="i">
          <mat-form-field class="context">
            <mat-label
              >{{ t('municipalities') }} : <b>{{ getLabelForRole(contextControl.value.roleCode) }}</b></mat-label
            >
            <mat-select
              formControlName="contextValues"
              multiple
              panelClass="list-540px"
              [disabled]="(getContextValuesForSelectedRole(contextControl.value.roleCode) | async)?.length === 0"
            >
              @for (contextValue of getContextValuesForSelectedRole(contextControl.value.roleCode) | async; track contextValue) {
              <mat-option [value]="contextValue.geoField">
                {{ contextValue.geoFieldAlias }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </ng-container>
        }
      </ng-container>
    </div>
  </div>
</form>
